<div class="bg-m1 flex h-full cursor-default flex-col">
  <div
    class="flex h-2 flex-1 flex-row items-center justify-center overflow-y-auto"
  >
    <div class="text-s2 mb-60 text-center text-2xl font-semibold">{{
      pageTitle
    }}</div>
  </div>
</div>
